/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Fragment } from 'react';
import { ListItem } from './ListItem';
import { Spinner } from './Spinner';
import { range, groupBy, map } from 'lodash';
import { Clickable } from './Clickable';
import { ListGroup } from './ListGroup';
export function List(_a) {
    var renderItem = _a.renderItem, items = _a.items, loading = _a.loading, placeholder = _a.placeholder, className = _a.className, skeleton = _a.skeleton, skeletonItem = _a.skeletonItem, _b = _a.skeletonCount, skeletonCount = _b === void 0 ? 10 : _b, hasMore = _a.hasMore, onMoreClick = _a.onMoreClick, loadingMore = _a.loadingMore, children = _a.children, groupByPredicate = _a.groupBy, renderHeading = _a.renderHeading;
    return (jsx("div", { className: className }, !items || loading ? (skeleton || skeletonItem ? (jsx(ListGroup, null,
        skeleton,
        skeletonItem &&
            range(0, skeletonCount).map(function (i) { return (jsx(ListItem, { key: i }, skeletonItem)); }))) : (jsx(ListGroup, null,
        jsx(ListItem, { sx: { textAlign: 'center', m: 3 } },
            jsx(Spinner, { size: "lg" }))))) : items.length === 0 ? (jsx(ListGroup, null,
        placeholder !== false && (jsx(ListItem, { sx: { fontSize: 1, color: 'muted', px: 2 } }, placeholder || 'Nothing to show')),
        children)) : (jsx(Fragment, null,
        groupByPredicate ? (items.length ? (map(groupBy(items, groupByPredicate), function (group) {
            return (jsx(Fragment, null,
                renderHeading && renderHeading(group[0]),
                jsx(ListGroup, null, group.map(function (item, index) { return renderItem(item, index); }))));
        })) : (jsx(ListGroup, null, children))) : (jsx(ListGroup, null,
            items.map(function (item, index) { return renderItem(item, index); }),
            children)),
        hasMore && (jsx(ListItem, { as: Clickable, onClick: onMoreClick, sx: { textAlign: 'center' } }, loadingMore ? jsx(Spinner, null) : 'Load more'))))));
}
//# sourceMappingURL=List.js.map